import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-register-error',
  templateUrl: './register-error.component.html',
  styleUrls: ['./register-error.component.scss'],
})
export class RegisterErrorComponent {
  constructor(public dialogRef: MatDialogRef<RegisterErrorComponent>) {}

  tryAgain() {
    this.onClose();
  }

  onClose() {
    document.getElementsByClassName('animate__animated')[0].classList.remove('animate__fadeInDown');
    document.getElementsByClassName('animate__animated')[0].classList.add('animate__fadeOutDown');
    setTimeout(() => {
      this.dialogRef.close();
    }, 500);
  }
}
